import { createGlobalState } from "@vueuse/core";

type TabType =
  | "dashboard"
  | "main"
  | "table"
  | "cart"
  | "job"
  | "togo"
  | "delivery"
  | "delivery_edit"
  | "activity"
  | "store"
  | "logs"
  | "soldout"
 
export const useTabs = createGlobalState(() => {
  // MAIN TABS
  const tabSelected = ref<TabType>("dashboard");
  const tableType = ref<TabType>("table");
  const setTab = (tab: TabType, type?: TabType) => {
    tabSelected.value = tab;
    tableType.value = type || "table";
  };

 

  return {
    tabSelected,
    tableType,
    setTab,
  };
});
